import { useEffect, useState } from "react";
import type { ShiftFormManagerDashboard, ShiftFormManagerDashboardFilters } from "../../../shared/shift-production-form/contracts";
import type { AnalysisMetric } from "./analysis-columns";
import { readMissingMeasurements } from "./analysis-missing-measurements";

type State = { phase: "loading" } | { phase: "ready"; rows: ShiftFormManagerDashboard["rows"] } | { phase: "error"; message: string };
export function useAnalysisMissingMeasurements(filters: ShiftFormManagerDashboardFilters, metric: AnalysisMetric, testMode = false) {
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState<State>({ phase: "loading" });
  const scope = JSON.stringify(filters);
  useEffect(() => {
    let active = true;
    setState({ phase: "loading" });
    const currentFilters: ShiftFormManagerDashboardFilters = JSON.parse(scope);
    void readMissingMeasurements(currentFilters, metric, async requestFilters => {
      const { getShiftFormManagerDashboard } = await import("../shift-production-form/shift-production-form-gateway");
      return getShiftFormManagerDashboard(requestFilters, testMode);
    }, () => active).then(rows => {
      if (active && rows) setState({ phase: "ready", rows });
    }).catch((error: unknown) => { if (active) setState({ phase: "error", message: error instanceof Error ? error.message : "Kayıtlar alınamadı." }); });
    return () => { active = false; };
  }, [scope, metric, revision, testMode]);
  return { state, retry: () => setRevision(value => value + 1) };
}
